<template>
  <div class="container">
    <div class="body">
      <headerDiv />
      <div class="total">
        <div class="one">
          <p class="p">{{ $t("register.one") }}</p>
          <div class="two Margin">
            <!-- <input type="text" οnkeyup="this.value=this.value.replace(/\s+/g,'')" v-model=""> -->
            <input
              type="text"
              :placeholder="$t('register.RequiredNameUser')"
              v-model="username"
            />
            <!-- <p>*&nbsp;{{$t('register.two')}}</p> -->
          </div>
          <div class="three Margin">
            <!-- οnkeyup="this.value=this.value.replace(/\s+/g,'')" -->
            <input
              type="text"
              :placeholder="$t('register.RequiredEal')"
              v-model="phone"
            />
          </div>
          <div class="two Margin">
            <input
              type="password"
              name=""
              id=""
              v-model="userpwd"
              :placeholder="$t('register.RequiredPwd')"
            />
            <!-- <p>*&nbsp;{{$t('register.three')}}</p> -->
          </div>
          <div class="three Margin">
            <input
              type="password"
              name=""
              id=""
              v-model="userpwdpwd"
              :placeholder="$t('register.ZcRequiredPwd')"
            />
          </div>
          <div class="three Margin">
            <!-- @on-change="changeAddress" -->
            <Select v-model="activeSelect" placeholder="886 台灣" style="width: 100px;height:43px" @on-change="changeAddress">
              <Option
                v-for="item in arraySelect"
                :value="item.id"
                :key="item.id"
                :label="item.Coury + ' ' + item.name"
                
              ></Option>
            </Select>
            <input
              type="text"
              :placeholder="$t('register.RequiredPhone')"
              v-model="email"
              oninput="value=value.replace(/\s+/g,'')"
              style="width:260px;margin:0 0 0 26px"
            />
          </div>
          <div class="five Margin">
            <input
              type="text"
              v-model="ReferenceNumber"
              :placeholder="$t('register.tjr')"
            />
            <p>{{ $t("register.four") }}</p>
          </div>
          <div class="five Margin">
            <p style="color:red;font-size:18px">來源：</p>
            <RadioGroup v-model="source">
              <Radio label="FB"><span>FB</span></Radio>
              <Radio label="淘宝"><span>淘寶</span></Radio>
              <Radio label="小红书"><span>小紅書</span></Radio>
              <Radio label="Google"><span>Google</span></Radio>
              <Radio label="百度推广"><span>百度推廣</span></Radio>
              <Radio label="朋友介绍"><span>朋友介紹</span></Radio>
              <Radio label="yahoo"><span>yahoo</span></Radio>
              <Radio label="其他"><span>其他</span></Radio>
            </RadioGroup>
            
            <!-- <input
              type="text"
              v-model="source"
              placeholder="来源（选填）"
            /> -->
          </div>
          <!-- <div class="six Margin">
            <div>
              <div class="check1" @click="dj((four = 0))" v-show="one"></div>
              <div class="check2" @click="dj((four = 1))" v-show="two">
                <img
                  src="../../../assets/images/gou.png"
                  alt=""
                  style="margin: 3px 0 0 4px"
                />
              </div>
            </div>
            <span @click="modal1 = true"
              >{{ $t("register.five") }}
              <span style="color: red; margin-left: -5px">《承運條款》</span></span
            >
          </div> -->
          <!-- 去登陆 -->
          <div class="logon" @click="denglu()">{{ $t("register.six") }}</div>
          <div class="border" @click="register()">
            {{ $t("register.Seven") }}
          </div>
        </div>
      </div>
    </div>
    <div >
        <!-- <div class="jt1" @click="sds" id="positon" v-if="Show">
          <img
            src="../../../assets/images/jtz.png"
            alt=""
            style="width: 75%; margin: 5px 0 0 5px"
          />
        </div> -->
        <!-- <Drawer :closable="false" v-model="value1" :mask="false" :scrollable="true">
          <div id="floatDivBoxs">
            <div class="floatDtt">在線客服</div>
            <div class="floatShadow">
              <ul class="floatDqq">
                <li style="padding-left: 0px">
                
                    <img
                      src="../../../assets/images/whatsapp.png"
                      height="16"
                      border="0"
                      alt="whatsapp"
                      align="absmiddle"
                    />
                    &nbsp;&nbsp;微信：15012573996
                  
                </li>
                <li style="padding-left: 0px">
                  <a
                    href="https://m.me/10533192155084"
                    target="_blank"
                  >
                    <img
                      src="../../../assets/images/whatsapp.png"
                      height="16"
                      border="0"
                      alt="whatsapp"
                      align="absmiddle"
                    />
                    &nbsp;&nbsp;天鳥集運</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </Drawer> -->
    </div>
    <!-- 对话框 -->
    <Modal v-model="modal1" title="集運服務條款細則" width="800">
      <div>
        一 關於時效<br /><br />
        <p>
          1.派寶集運截單時間爲<span class="Modal">（周日至周五）每天淩晨12點</span
          >，週六及香港假期前一天除外。截單時間前完成付款當天（工作日）安排發貨。中轉站週六及香港紅日前一天均不發貨，周天或公眾假期香港派送公司不予貨物派送。節假日具體安排請留意派寶集運官網<span
            class="ModalA"
            >www.paibaoex.com</span
          >通知，具體變動以派寶集運官網<span class="ModalA">www.paibaoex.com</span>爲準。
        </p>
        <br />
        <p>
          2.派寶集運訂單發貨後正常隔天到港。到港後訂單一般當天（工作日）派送，偏遠地區一般需要隔天派送。特殊情況：當遇上天氣惡劣/海關查處/雨天/公眾假期/偏遠地區/6.18/雙11/雙12等情況，爲了保證貨物安全，貨物可能會延遲派送，特殊情況請留意派寶集運官網公告。
        </p>
      </div>
      <br />
      <div>
        二 運費付款細則<br /><br />
        <p>
          1.客戶在派寶集運官網<span class="ModalA">www.paibaoex.com</span
          >或派寶集運APP申請集包後，還需要到淘寶店鋪付款我們才能安排發貨，如果運費需要到付請聯繫客服。
        </p>
        <br />
        <p>
          2.如收件地址爲非工商區或偏遠地區，付款時沒有支付附加費，必須安排補付運費，否則不予安排送貨。
        </p>
        <br />
        <p>
          3.客戶必須如實申報貨物品名，收件地址信息（工商區/非工商區），是否敏感。并按照對應價格支付運費，否則必須補齊差價才可安排發貨。
        </p>
        <br />
        <p>4.因付款不及時造成發貨時效延誤，派寶集運不承擔任何相關責任。</p>
        <br />
        <p>
          5.每票訂單貨物體積重量與實際貨物重量作比較，取較重者計算運費。派寶集運根據國際標準及物流行業慣例，體積重量計算公式爲：體積重量=長*寬*高（cm）/6000。請客戶在購買貨物之前弄清貨物實際體積，以免造成費用誤會。
        </p>
        <br />
        <p>6.貨物集包後不足1KG部分按1KG核算運費。</p>
        <br />
        <p>
          7.如果貨物重量超重或體積超大需要額外聘用其他設備卸裝搬運的，我們將另外收取費用。具體標準聯繫派寶集運客服。
        </p>
        <br />
        <p>
          8.訂單一經確認如需取消訂單，請聯繫派寶集運客服。根據實際情況處理，如已經裝車發貨則取消不了訂單，未裝車取消訂單需收取10元/票操作費用。
        </p>
        <br />
        <p>9.關於派寶集運收取費用問題，派寶集運擁有最終裁決權！</p>
        <br />
      </div>
      <br />
      <div>
        三 有關快遞派送收貨事宜<br /><br />
        <p>
          1.爲保障貨物安全快遞公司會按照訂單指定地址送貨，如要更改送貨地址將會產生額外送貨費用，延長派送時效，具體聯繫派寶集運客服。
        </p>
        <br />
        <p>2.如客戶提供的地址有誤，在派送時出現的任何問題，派寶集運將不承擔任何責任。</p>
        <br />
        <p>
          3.客戶必須如實申報貨物品名，收件地址信息（工商區/非工商區），是否敏感。并按照對應價格支付運費，否則必須補齊差價才可安排發貨。
        </p>
        <br />
        <p>3.出現以下情況派送公司將會不搬運上樓，收貨人必須自己下樓取件：</p>
        <br />
        <p>A.派送地址沒辦法提供免費泊車。</p>
        <br />
        <p>B.沒有升降機，需要經樓梯搬運。</p>
        <br />
        <p>C.需要上樓才能到達升降機上樓的。</p>
        <br />
        <p>D.貨物重量/體積/長度超大，不能使用升降機或使用升降機一次搬運不完的。</p>
        <br />
        <p>E.停車位置距離升降機門口超20米的。</p>
        <br />
        <p>
          F.大型貨物或傢俱傢私派送須在樓下交收，不派送上樓；機器、建材等大型貨物必須提供有讓叉車着力操作的卡板！
        </p>
        <p>大型貨物定義如下：</p>
        <p>
          單票（一個訂單）重量≥50KG（實際重量或體積重量），或單件（合包後一件）重量≥40KG，或長寬高之和≥200CM，或長度＞150CM的貨物在樓下交收，不派送上樓；
        </p>
        <br />
        <p>
          4.如果派送員到達收貨地址，一直聯繫不上收件人的，貨物被退回存放於物流倉庫，產生的二次派送費用由客戶自行承擔。
        </p>
        <br />
        <p>
          5.派寶集運對於以下原因造成訂單派送延誤/派送錯誤及不能派送等任何損失將不承擔任何責任：
        </p>
        <p>A.由於客戶原因填寫地址錯誤/電話號碼錯誤或不全等。</p>
        <p>B.收件人地址變更或無法送達的地區。</p>
        <p>
          C.由於訂單物品違反了國家相關政策和法規明確禁止的物品。例如：易燃易爆，易腐蝕，易污染，有毒的粉末或液體，槍支彈藥等物品。
        </p>
        <p>D.因客戶未經聲明或貨物包裝不當導緻的貨物破損等。</p>
      </div>
      <br />
      <div>
        四 貨物破損及遺失處理<br /><br />
        <p>1.申報規則如下：</p>
        <p>
          A.如果貨物有遺失或破損，客戶必須在簽收貨物後24小時之內以打電話或派寶集運旺旺聯繫客服申報，如超時派寶集運默認貨物已經正常派送，不在接受遺失申報。
        </p>
        <p>B.申報時必須將清晰拍照外包裝袋和清晰的派送面單照片，派送單號必須拍照清晰。</p>
        <p>
          C.拆袋時必須先清點包裹內集包小貨數量，數量無誤再拆包裹內集包小貨。如果將所有集包小貨全部拆散之後再申報貨物遺失/少件，派寶集運將不予申報處理不承擔任何責任。
        </p>
        <p>
          D.收件時發現外包裝破損時，請拍下貨物外包裝圖片和拆包時短視頻發作爲破損遺失證據給派寶集運客服。
        </p>
        <p>E.提供貨物物品真實購買價值付款鏈接和截圖。</p>
        <br />
        <p>
          2.以上申報信息齊全經派寶集運客服確認屬實後，進行賠償，賠償金額最高爲運費每筆集運後運費三倍。
        </p>
        <br />
        <p>
          3.如果丟失物品在審核賠償時找回，派寶集運將選擇從新派送，將不予賠償。如有任何爭議，派寶集運保留最終決定權。
        </p>
        <br />
        <p>
          4.如果遺失的貨物是違禁物品和仿牌等禁運物品，或海關查扣查驗，派寶集運一律不予賠償。派寶集運保留最終決定權。
        </p>
        <br />
        <p>
          5.遺失理賠範圍只包括派寶集運倉庫至客戶收件地址運輸派送段，不包含客戶購買地至派寶集運倉庫運輸段。理賠確認付款時間將在5個工作日完成。派寶集運保留最終決定權。
        </p>
        <p>
          6.如因客戶購買貨物的外包裝質量不能滿足多次轉運條件而導緻物品破損或遺失時，派寶集運將不予理賠處理。除非可以提供外包裝專業的檢測報告能夠證明外包裝能夠滿足多次轉運條件則可以申報處理。
        </p>
        <p>
          7.如訂單貨物爲陶瓷/玻璃製品/工藝品等易損易破易變形物品，則客戶因確保良好的外包裝和良好的內包裝措施。（外包裝確保有木箱木架或鐵箱鐵架，內包裝確保有泡沫或國定物填充，確保能承受一定壓力）否則派寶集運將不予承擔任何責任，派寶集運將擁有最終決定權。
        </p>
        <br />
      </div>
      <br />
      <div>
        五 承運條款<br /><br />
        <p>
          1.派寶集運客戶需承諾派寶集運有權放棄或不收；不宜試於運輸方式的貨物，有意或無意隱瞞貨物真實品名和價值的，國家法規命令禁止郵寄運輸攜帶的物品。一經發現客戶將承擔由此產生的一切法律責任和一切經濟損失賠償。
        </p>
        <br />
        <p>
          2.派寶集運所有客戶必須保證和接受派寶集運所公佈的貨物運價和相關的存倉/退倉/轉運的所有相關費用。
        </p>
        <br />
        <p>
          3.如因客戶的貨物溢出/滲出/漏出任何液體或固體，導緻其他貨物損毀時，派寶集運將有權追究一切相關導緻的經濟損失和法律責任。
        </p>
        <br />
        <p>
          4.派寶集運有權獲知承運物品名稱，性質，材質，數量，重量和價值。以協助相關部門和海關對承運物品進行檢查。
        </p>
        <br />
        <p>
          5.承運貨物到達派寶集運倉庫，如需退倉和專寄其他地方，具體收費以派寶集運客服溝通價格爲準。
        </p>
        <br />
        <p>6.貨物未能送達派寶集運倉庫要求接貨產生的一切提貨費用由客戶承擔。</p>
        <br />
        <p>
          7.貨物到達派寶集運倉庫後必須在180天內下單寄出，否則派寶集運將物品作棄件處理。派寶集運擁有貨物自行處理權，客戶不得有任何意義，派寶集運對棄件有最終決定權。
        </p>
        <br />
        <p>
          8.客戶自支付運費起即表示接受和遵守本契約之條款，保證所運輸的貨物符合國家法律和快遞行業能夠接受的物品。派寶集運拒絕接受以下物品：
        </p>
        <p>A.易燃易爆易腐蝕的具有毒性，爆炸性，殺傷性，腐蝕性和放射性物品。</p>
        <p>B.藥物和具有傳染性，妨害公共衛生品和毒品/吸毒相關器具。</p>
        <p>C.侵犯商標，著作權和智慧財產權物品。</p>
        <p>
          D.貨幣，增值稅發票和其他稅票或有價證券，金銀財寶，古董和貴重金屬（金，銀，稀有貴金屬）。
        </p>
        <p>E.活體動物，植物和種子。</p>
        <p>F.私人證件，合同，批文和具備通信性質書函。</p>
        <p>G.反動政治刊物，書籍，錄像和影碟。</p>
        <p>H.非正品/仿製品/來源不正當物品。</p>
        <p>I.包裝不穩妥，可能會造成人身傷害或可能導緻其他貨物污損物品。</p>
        <p>
          J.不符合《中華人民共和國產品質量法》，《中華人民共和國香港法》，《中華人民共和國消費者權益保障法》和其他法規部門強制性標準規定的物品。
        </p>
        <p>
          如客戶使用派寶集運<span class="ModalA">www.paibaoex.com</span
          >服務獎默認同意以上所有條款，派寶集運將保留最終解釋權。
        </p>
      </div>
    </Modal>
  </div>
</template>
<script>
// import {GVerify} from "./code.js"
import md5 from "js-md5";
import headerDiv from "../../layout/header/index.vue";

// import { isTrack } from "../../../utills/track.js";
// import { ddd } from "../../../utills/dd.js";
export default {
  data() {
    return {
      modal1: false,
      username: "",
      userpwd: "",
      userpwdpwd: "",
      phone: "",
      model1: "",
      four: 0,
      one: true,
      two: false,
      ReferenceNumber: "",
      syck: [],
      email: "",
      js:"",
      value1: true,
     source:"",
     activeSelect:"",
     arraySelect:[
       {
         id:0,
         Coury:"886",
         name:"台灣"
       },
       
       {
         id:1,
         Coury:"60",
         name:"馬來西亞"
       },
       {
         id:2,
         Coury:"1",
         name:"美國"
       },
       {
         id:3,
         Coury:"65",
         name:"新加坡"
       },
       {
         id:4,
         Coury:"81",
         name:"日本"
       },
       {
         id:5,
         Coury:"852",
         name:"香港"
       },
       {
         id:6,
         Coury:"86",
         name:"中國"
       },
       {
         id:7,
         Coury:"61",
         name:"澳大利亞"
       },
       {
         id:8,
         Coury:"1",
         name:"加拿大"
       },
       {
         id:9,
         Coury:"44",
         name:"英國"
       },
       {
         id:10,
         Coury:"8",
         name:"韓國"
       },
       {
         id:11,
         Coury:"64",
         name:"新西蘭"
       },
       {
         id:12,
         Coury:"66",
         name:"泰國"
       },
       {
         id:13,
         Coury:"0063",
         name:"菲律宾"
         
       }
     ],
     CourHd:"886"
    };
  },
  components: {
    headerDiv,
  },
  mounted() {
    this.queryUrl();
    const id = this.$route.query.id;
    if (id) {
      this.ReferenceNumber = id;
    }
  },
  methods: {
     changeAddress(vId){
       let obj = {};
      obj = this.arraySelect.find((item) => {
        return item.id === vId;
      });
      this.CourHd = obj.Coury
      console.log(this.CourHd, "this.payID");
     },
    denglu() {
      this.$router.push({
        path: "./login",
        query: {
          Code: true,
        },
      });
    },
    dj() {
      if (this.four == 0) {
        this.one = false;
        this.two = true;
      } else if (this.four == 1) {
        this.one = true;
        this.two = false;
      }
    },
    async queryUrl() {
      const _md5 = md5('{"Url":"member.haohong56.com"}123456');
      const params = {
        JsonData: '{"Url":"member.haohong56.com"}',
        CusID: localStorage.getItem("CusID"),
        KeyMd5: _md5,
      };
      const { data } = await this.$post("/QueryUrl", params, true);
      if (data.State) {
        const storeInfo = JSON.parse(data.ReturnJson);
        document.title = storeInfo.Name;
        localStorage.setItem("CusID", storeInfo.CusID);
        localStorage.setItem("shopName", storeInfo.Name);
        localStorage.setItem("KeyText", storeInfo.KeyText);
        localStorage.setItem("phone", storeInfo.Phone);
      }
    },
    async register() {
      // 手机号
      // ddd();
      // let Phone = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
      // this.CourHd
      var regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      var reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (this.username == "") {
        this.$Message.error("用戶名不能爲空");
        return false;
      } else if (this.phone == "") {
        this.$Message.error("郵箱不能為空");
        return false;
      } else if (this.userpwd == "") {
        this.$Message.error("密碼不能爲空");
        return false;
      } else if (this.userpwdpwd == "") {
        this.$Message.error("密碼不能爲空");
        return false;
      } else if(this.CourHd == ""){
        this.$Message.error("請選擇區號");
        return false;
      } else if (this.email == "") {
        this.$Message.error("手機號不能爲空");
        return false;
      } else if(this.source == ""){
        this.$Message.error("請選擇來源");
        return false;
      } else if (this.username.length < 2) {
        this.$Message.error("用戶名不能小於兩位");
        return false;
      } else if (this.userpwd.length < 6) {
        this.$Message.error("密碼位數不能低於6位！");
        return false;
      } else if (this.userpwdpwd != this.userpwd) {
        this.$Message.error("兩次密碼不壹置！");
        return false;
      } else {
        let PhonEq = this.CourHd + this.email
        const params = {
          ReferenceNumber: this.ReferenceNumber,
          ClientName: this.username,
          Email: this.phone,
          Mobile: PhonEq,
          Password: this.userpwdpwd,
          RePassword: this.userpwdpwd,
          WeiboId: "",
          enname: "",
          reg_come:this.source
        };
        const { data } = await this.$post("Client_Registered", params);
        if (data.State) {
          this.$Message.success("註冊成功！");
          this.$router.push({
            path: "./login",
            query: {
              Code: true,
            },
          });
          window.fbq('track', 'CompleteRegistration')
          // this.$router.push("./login");
        } else {
          this.$Message.error(data.MsgText);
          return false;
        }
      }
      // else if (this.one == true) {
      //   this.$Message.error("请阅读并同意《承运条款》");
      //   return false;
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.ivu-select-single .ivu-select-selection {
    height: 39px;
    position: relative;
}
/deep/.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value{
  line-height: 40px;
}
/deep/ .ivu-drawer-content {
  box-shadow: none !important;
  background-color: #fff0 !important;
}
/deep/ .ivu-drawer-content {
  width: 1%;
  height: 1%;
}
.jt1{
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  // top: 0;
  right: 0;
  background: #f0c026;
  border: 1px solid #00000026;
}
.jt {
  height: 45px;
  width: 49px;
  /* margin: 0 auto; */
  position: absolute;
  top: 80px;
  right: 163px;
  background: #f0c026;
}
.one {
  position: relative;
  left: -200px;
}
#floatDivBoxs {
  width: 170px;
  background: #fff;
  position: fixed;
  top: 180px;
  right: 0;
  z-index: 999;
}
#floatDivBoxs .floatDtt {
  width: 100%;
  height: 45px;
  line-height: 45px;
  background: #f08326;
  color: #fff;
  font-size: 18px;
  text-indent: 22px;
  position: relative;
}
#floatDivBoxs .floatDqq {
  padding: 0 14px;
}
#floatDivBoxs .floatDqq li {
  height: 45px;
  line-height: 45px;
  // font-size: 15px;
  border-bottom: 1px solid #e3e3e3;
  padding: 0 0 0 50px;
}
a {
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  color: #666666;
}
#floatDivBoxs .floatDqq li a {
  color: #333;
}
#floatDivBoxs .floatDtxt {
  font-size: 18px;
  color: #333;
  padding: 12px 14px;
}
#floatDivBoxs .floatDtel {
  padding: 0 0 15px 10px;
  color: #f08326;
  font-size: 18px;
}
#floatDivBoxs .floatDbg {
  width: 100%;
  height: 20px;
  background: url("../../../assets/images/online_botbg.jpg") no-repeat;
  box-shadow: -2px 0 3px rgba(0, 0, 0, 0.25);
}
#floatDivBoxs .floatDewm {
  text-align: center;
  padding: 10px 0 5px 0;
  background: #ebebeb;
  color: #333;
}
#floatDivBoxs .floatDewm img {
  width: 106px;
  height: 106px;
}
/deep/ .ivu-modal-content {
  font-size: 18px;
}
/deep/ .ivu-modal-content .Modal {
  color: red !important;
}
/deep/ .ivu-modal-content .ModalA {
  color: red !important;
  text-decoration: underline;
  cursor: pointer;
}
/deep/.ivu-modal-body {
  font-size: 14px;
}
.container {
position: relative;
  width: 100%;
  @include backgroundColor($_color);
  height: 100vh;
  .body {
    // background: url('../../../assets/images/bg.png')no-repeat center center;
    // height: 100vh;width:100%;
    // background-size: 100% 100%;
    // background-position: -400px 0;
    background: url("../../../assets/images/BG.png") no-repeat 50%;
    height: 100vh;
    width: 100%;
    background-size: 100% 100%;
  }
  ::-webkit-input-placeholder::before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
  .total {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .one {
      width: 500px;
      height: 600px;
      background: #fff;
      box-shadow: 0px 0px 30px 0px rgba(35, 21, 24, 0.35);
      border-radius: 20px;
      margin: 20px 190px 0 0;
      padding: 0 54px;
      position: relative;
      .Margin {
        margin: 10px 0;
      }
      .logon {
        position: absolute;
        bottom: 40px;
        right: 50px;
        text-decoration: underline;
        color: red;
        font-size: 20px;
        cursor: pointer;
      }
      .p {
        font-size: 32px;
        font-weight: bold;
        color: #333;
        padding: 20px 0 10px 0;
      }
      .pdw {
        font-size: 14px;
        font-weight: 500;
        color: #0099ff;
        margin: -29px 0 0 0;
        cursor: pointer;
      }
      .two {
        // margin: 0px 0 5px 0;
        input {
          width: 390px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
        p {
          font-size: 12px;
          color: red;
          cursor: pointer;
          padding: 5px 0 0 0;
        }
      }
      .three {
        // margin: 0 0 10px 0;
        p {
          color: red;
        }
        .span::before {
          content: "*";
          display: inline-block;
          margin-right: 4px;
          line-height: 1;
          font-family: SimSun;
          font-size: 12px;
          color: #ed4014;
        }
        input {
          width: 390px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
        #select{
          width: 100px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
      }
      /deep/ .four {
        display: flex;
        flex-direction: row;
        // margin: 30px 0 0 0;
        input {
          width: 293px;
          height: 60px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
          margin: 0 0 0 10px;
        }
        .code {
          width: 156px;
          height: 60px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
        }
        #verifyCanvas {
          width: 153px;
          height: 56px;
        }
        .ivu-select-selected-value {
          display: block;
          height: 41px;
          line-height: 60px;
          font-size: 20px;
        }
        .ivu-select-single .ivu-select-selection {
          position: relative;
          height: 58px;
        }
        .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
        .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
          font-size: 20px;
          line-height: 60px;
          height: 40px;
          color: #999;
        }
      }
      .five {
        margin: 5px 0 0px 0;
        input {
          width: 390px;
          height: 43px;
          background: #fafafa;
          border: 2px solid #e4e4e4;
          opacity: 0.6;
          border-radius: 5px;
          text-indent: 1em;
        }
        p {
          font-size: 12px;
          color: #999;
          padding: 5px 0 0 0;
        }
      }
      .six {
        position: relative;
        display: flex;
        flex-direction: row;
        margin: 10px 0 0 10px;
        .check1 {
          width: 19px;
          height: 19px;
          background: #fff;
          border-radius: 50%;
          border: 1px solid #c2c2c2;
          position: absolute;
          top: 0;
        }
        .check2 {
          width: 19px;
          height: 19px;
          background: red;
          border-radius: 50%;
          position: absolute;
          top: 0;
        }
        span {
          margin: 0 0 0 25px;
          cursor: pointer;
          font-weight: 500;
          color: #000;
          // width: 100px;
          // text-decoration: underline;
        }
      }
      .border {
        width: 230px;
        height: 60px;
        @include backgroundColor($_color);
        // background: #ff3333;
        border-radius: 10px;
        font-size: 36px;
        text-align: center;
        font-weight: bold;
        color: #ffffff;
        line-height: 60px;
        margin: 18px 0 0 82px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/view/signup/register.vue